import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  class: "feather feather-send"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("line", {
      x1: "22",
      y1: "2",
      x2: "11",
      y2: "13"
    }, null, -1),
    _createElementVNode("polygon", { points: "22 2 15 22 11 13 2 9 22 2" }, null, -1)
  ]))]))
}
export default { render: render }